import { createSelector } from '@reduxjs/toolkit';

export const tickGroupTableSelector = (state) =>
  state.ticketGroupTable;

export const ticketGroupTableSelectAllSelector = createSelector(
  tickGroupTableSelector,
  (ticketGroupTableStore) => ticketGroupTableStore.selectedAll,
);

export const ticketGroupTableSelectedIdSelector = createSelector(
  tickGroupTableSelector,
  (ticketGroupTableStore) => ticketGroupTableStore.selectedId,
);

export const ticketGroupTableSelectedIdsListSelector = createSelector(
  ticketGroupTableSelectedIdSelector,
  (selectedIdMap) => {
    return Object.keys(selectedIdMap).filter(
      (id) => selectedIdMap[id] === true,
    );
  },
);

export const ticketGroupTableSelectedIdCountSelector = createSelector(
  ticketGroupTableSelectedIdSelector,
  (selectedId) => {
    return (
      selectedId &&
      Object.values(selectedId).filter((val) => !!val).length
    );
  },
);

export const showBulkActionBarSelector = createSelector(
  ticketGroupTableSelectedIdCountSelector,
  (count) => count > 0,
);
